/**
 * tp-delivery-checker.js — postal (FSA) delivery-availability widget for marketing pages.
 *
 * REWRITTEN 2026-07-12: was a hand-maintained snapshot of zone FSA lists that drifted out of date
 * (e.g. Stouffville had only L4A, N0B lingered). Now it reads the SAME single source of truth as
 * the cart drawer + /cart stepper — window.TPDeliveryData (tp-delivery-data.js), which mirrors the
 * canonical docs/delivery-and-pickup-reference.md. So coverage / zone names / windows / fees stay
 * automatically in sync across every component. Load tp-delivery-data.js before this script.
 */
(function () {
  if (window.tpDeliveryCheckerLoaded) return;
  window.tpDeliveryCheckerLoaded = true;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }  // used for the midday surcharge badge
  function el(tag, text) { var e = document.createElement(tag); if (text != null) e.textContent = text; return e; }
  function strong(t) { return el('strong', t); }
  function br() { return document.createElement('br'); }

  // safe DOM render (no innerHTML) — nodes = array of strings | elements
  function renderResult(result, nodes, success) {
    result.textContent = '';
    nodes.forEach(function (n) { result.appendChild(typeof n === 'string' ? document.createTextNode(n) : n); });
    result.classList.add('is-visible');
    result.classList.toggle('is-success', !!success);
    result.classList.toggle('is-error', !success);
  }

  // Fee phrase comes from the ONE canonical source (TPDeliveryData.feeSummary) — never hardcoded
  // here — so a price change anywhere is a single edit in tp-delivery-data.js. Capitalise for
  // mid-sentence use: "from $5.59 (free over $85.00)" → "From $5.59 (free over $85.00)."
  function feeText(data, feeZone) {
    var s = data.feeSummary ? data.feeSummary(feeZone) : '';
    if (!s) return '';
    return s.charAt(0).toUpperCase() + s.slice(1) + '.';
  }

  function describe(data, cov) {
    var out = [];
    if (cov.kind === 'special') {
      out.push(strong('Selected-day delivery to ' + cov.fsa + ' — ' + cov.zoneName + '.'));
      out.push(br());
      var sw = (cov.windows && cov.windows[0] && cov.windows[0].label) || '6:45–11:30 PM';
      out.push(cov.days.join(' · ') + ' · ' + sw + '. ' + feeText(data, cov.feeZone) +
        ' Book up to 180 days ahead; final date & pricing confirmed in cart.');
      return out;
    }
    // daily core (evening, ± afternoon/midday)
    out.push(strong('We deliver to ' + cov.fsa + ' — ' + cov.zoneName + '.'));
    out.push(br());
    var W = data.WINDOWS || {};
    var line = 'Evening ' + ((W.evening && W.evening.label) || '5:30–10:30 PM') + ' daily';
    var hasMidday = (cov.windows || []).some(function (w) { return w.kind === 'midday'; });
    if (hasMidday) {
      line += ', plus afternoon 1:30–5:00 PM from the next day';
      if (cov.surchargeCharge > 0) line += ' (+' + money(Math.round(cov.surchargeCharge * 100)) + ')';
    }
    line += '. ' + feeText(data, cov.feeZone) + ' Book up to 180 days ahead; final options confirmed in cart.';
    out.push(line);
    return out;
  }

  function bindChecker(checker) {
    if (checker.dataset.tpDeliveryCheckerReady === 'true') return;
    checker.dataset.tpDeliveryCheckerReady = 'true';

    var input = checker.querySelector('input[name="postal_code"]');
    var result = checker.querySelector('[data-tp-delivery-result]');
    if (!input || !result) return;

    checker.addEventListener('submit', function (event) {
      event.preventDefault();
      var data = window.TPDeliveryData;
      if (!data) { renderResult(result, ['Delivery lookup is still loading — please try again in a moment.'], false); return; }

      var cov = data.lookupFSA(input.value);
      if (cov.reason === 'incomplete' || cov.fsa.length < 3) {
        renderResult(result, [strong('Enter the first 3 characters of your postal code.'), ' Example: M5V, L3R, or M2N.'], false);
        return;
      }
      if (!cov.deliverable) {
        renderResult(result, [
          strong('We may not deliver to ' + cov.fsa + ' yet.'), br(),
          'You can still choose free pickup from our Markham studio (505 Hood Rd, Unit 10), or contact us to confirm options.',
        ], false);
        return;
      }
      renderResult(result, describe(data, cov), true);
    });
  }

  function init() {
    document.querySelectorAll('[data-tp-delivery-checker]').forEach(bindChecker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
